import { transformBoxShadowToDropShadow } from "../../../helpers";
import shadows from "../../../../theme/foundations/generated/shadows";
const ComponentStyle = {
    baseStyle: {
        padding: "4",
        backgroundColor: "semantic.foreground.primary",
        color: "semantic.text.inverse",
        "--popper-arrow-bg": "colors.semantic.foreground.primary",
        borderRadius: "0",
        filter: `drop-shadow(${transformBoxShadowToDropShadow(shadows.large)})`,
    },
};
export default ComponentStyle;
//# sourceMappingURL=Tooltip.default.js.map